/**
 * External Dependencies
 */
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createLogger from 'redux-logger'
import thunk from 'redux-thunk';
import { routerReducer } from 'react-router-redux';

/**
 * Internal Dependencies
 *
 * These are the subtrees of the Redux store. Each
 */
import articles from './reducers/articles';
import sites from './reducers/sites';
import settings from './reducers/settings';

// Combine all our reducers into one rootReducer
const rootReducer = combineReducers({
    articles,
    sites,
    settings,
    routing: routerReducer
});

// Create the logger middleware
const loggerMiddleware = createLogger();

// Configures the store and exports it to make it available to other parts of the application
export default function configureStore( initialState = {} ) {

    return createStore( rootReducer, initialState, compose(
        applyMiddleware( thunk, loggerMiddleware ),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    ));

}


/** WEBPACK FOOTER **
 ** ./src/state/index.js
 **/